export default __webpack_public_path__ + "static/media/home.5e8e2e2a.svg";